// extracted by mini-css-extract-plugin
export default {"container":"OrderApproval_container__JVaNR"};